<template>
    <div class="column-container">
        <banner wzades="一件事主题服务" aria-label="一件事主题服务" outBannerHeight="320px" :bannerAttachPath="bannerPic" :defaultBanner="defaultBanner">
            <div class="banner-title">
                一件事主题服务{{
                    $store.state.chosenAreaInfo && $store.state.chosenAreaInfo.jcAreaSeq.indexOf('4417') == 0 ? '（试行版）' : ''
                }}
                <div class="banner-subtitle">
                    <div><i class="banner-icon"></i><span class="info">一表申报</span><span>协同办理</span></div>
                    <div><i class="banner-icon"></i><span class="info">一套材料</span><span>统一出证</span></div>
                    <div><i class="banner-icon"></i><span class="info">一次提交</span><span>一体管理</span></div>
                </div>
            </div>
        </banner>

        <div class="main-content">
            <div class="main-content-section" wzades="一件事一次办" aria-label="一件事一次办">
                <div class="main-content-title">
                    <div class="main-content-title-bg">一件事一次办</div>
                </div>
                <div class="main-content-content">
                    <div class="main-content-content_dash">
                        从群众办事的角度出发，希望开餐馆、希望开奶茶店、希望办高校毕业生落户、希望申请人才安居补贴等等都可以作为“一件事”。对群众来说简单的“一件事”，过去需要分别前往多个不同的政府部门申请办理，才能真正办完“一件事”；现在<span
                        class="blue-font">只需要完成一次申请</span>，所有相关的政府部门就能同时办理。办事群众可以选择网上办理“一件事”，也可以前往综合窗口办理。一件事服务建立系统联动、协同共享机制，实现线上线下“一次联办”，<span
                        class="blue-font">减免申请材料，减少跑动次数，减少办理环节，减少等待时间</span>，一次送达所有办理结果的目标，全面提升办事效率，方便办事群众，实现事项全流程标准化办理、运行全过程标准化监管。
                    </div>
                </div>
            </div>

            <div class="main-content-section" wzades="热门主题" aria-label="热门主题" v-if="hotThemes.length">
                <div class="main-content-title">
                    <div class="main-content-title-bg">热门主题</div>
                </div>
                <div class="main-content-content">
                    <div class="main-content-content_shadow"><div class="indicators-group">
              <button class="indicator" type="button" :class="{'is-active': activeHotTheme == index}" v-for="(item, index) in hotThemes" :key="item.typeSeq" @keyup="onkeydownFun" @click="clickIndicator(index)" :tabindex="activeHotTheme == index ? '0' : '-1'"></button>
            </div>
            <div class="theme-container" :style="{'width': 1200 * hotThemes.length + 'px', 'left': - activeHotTheme * 1200 + 'px'}">
              <div class="carousel-theme" v-for="(item, index) in hotThemes" :key="item.typeSeq">
                <div class="carousel-theme-title">
                  {{item.typeName}}
                  <div class="carousel-theme-title_bg"></div>
                  <span class="carousel-theme-type">{{ item.isEnterprise | enterpriseFormat }}</span>
                </div>
                <div class="carousel-theme-intro">{{ item.typeDesc }}</div>
                <div class="carousel-theme-compare">
                  <div class="carousel-theme-compare_icon">
                    <div class="icon">
                      <img src="../../../../assets/img/column/time.svg" alt="">
                      <div>办理时限</div>
                    </div>
                    <div class="icon">
                      <img src="../../../../assets/img/column/material.svg" alt="">
                      <div>申报材料</div>
                    </div>
                    <div class="icon">
                      <img src="../../../../assets/img/column/tache.svg" alt="">
                      <div>办理环节</div>
                    </div>
                    <div class="icon">
                      <img src="../../../../assets/img/column/run.svg" alt="">
                      <div>跑动次数</div>
                    </div>
                  </div>
                  <div class="carousel-theme-compare-data old-data">
                    <div class="compare-title">分开办</div>
                    <div class="compare-data">
                      <div class="data">{{ item.serviceInfo ? item.serviceInfo.handleLimitBefore : '' }} 个工作日</div>
                      <div class="data">{{ item.serviceInfo ? item.serviceInfo.stuffNumsBefore : '' }} 份</div>
                      <div class="data">{{ item.serviceInfo ? item.serviceInfo.handleStepBefore : '' }} 个</div>
                      <div class="data">{{ item.serviceInfo ? item.serviceInfo.runNumsBefore : '' }} 次</div>
                    </div>
                  </div>
                  <div class="carousel-theme-compare-data new-data">
                    <div class="compare-title">一次办</div>
                    <div class="compare-data">
                      <div class="data"><span class="red-font">{{ item.serviceInfo ? item.serviceInfo.handleLimitAfter : '' }}</span> 个工作日</div>
                      <div class="data"><span class="red-font">{{ item.serviceInfo ? item.serviceInfo.stuffNumsAfter : '' }}</span> 份</div>
                      <div class="data"><span class="red-font">{{ item.serviceInfo ? item.serviceInfo.handleStepAfter : '' }}</span> 个</div>
                      <div class="data"><span class="red-font">{{ item.serviceInfo ? item.serviceInfo.runNumsAfter : '' }}</span> 次</div>
                    </div>
                  </div>
                </div>
                <div class="carousel-theme-operation">
                  <el-button :tabindex="activeHotTheme == index ? '0' : '-1'" class="minor-btn" @click="goGraphic(item)">图文说明</el-button>
                  <el-button :tabindex="activeHotTheme == index ? '0' : '-1'" v-if="item.isOnlineApply == 1" type="primary" @click="chooseSubject(item)">立即办理</el-button>
                </div>
              </div>
            </div>
                        <!--            <el-carousel class="main-content-content_carousel" trigger="click" arrow="never"
                                     :interval="10000">
                            <el-carousel-item v-for="item in hotThemes" :key="item.typeSeq">
                                <div class="carousel-theme">
                                    <div class="carousel-theme-title">
                                        {{ item.typeName }}
                                        <div class="carousel-theme-title_bg"></div>
                                        <span class="carousel-theme-type">{{
                                                item.isEnterprise | enterpriseFormat
                                            }}</span>
                                    </div>
                                    <div class="carousel-theme-intro">{{ item.typeDesc }}</div>
                                    <div class="carousel-theme-compare" v-if="item.serviceInfo">
                                        <div class="carousel-theme-compare_icon">
                                            <div class="icon">
                                                <img src="../../../../assets/img/column/time.svg" alt="">
                                                <div>办理时限</div>
                                            </div>
                                            <div class="icon">
                                                <img src="../../../../assets/img/column/material.svg" alt="">
                                                <div>申报材料</div>
                                            </div>
                                            <div class="icon">
                                                <img src="../../../../assets/img/column/tache.svg" alt="">
                                                <div>办理环节</div>
                                            </div>
                                            <div class="icon">
                                                <img src="../../../../assets/img/column/run.svg" alt="">
                                                <div>跑动次数</div>
                                            </div>
                                        </div>
                                        <div class="carousel-theme-compare-data old-data">
                                            <div class="compare-title">分开办</div>
                                            <div class="compare-data">
                                                <div class="data">{{ item.serviceInfo.handleLimitBefore }} 个工作日
                                                </div>
                                                <div class="data">{{ item.serviceInfo.stuffNumsBefore }} 份</div>
                                                <div class="data">{{ item.serviceInfo.handleStepBefore }} 个</div>
                                                <div class="data">{{ item.serviceInfo.runNumsBefore }} 次</div>
                                            </div>
                                        </div>
                                        <div class="carousel-theme-compare-data new-data">
                                            <div class="compare-title">一次办</div>
                                            <div class="compare-data">
                                                <div class="data"><span
                                                    class="red-font">{{ item.serviceInfo.handleLimitAfter }}</span> 个工作日
                                                </div>
                                                <div class="data"><span
                                                    class="red-font">{{ item.serviceInfo.stuffNumsAfter }}</span> 份
                                                </div>
                                                <div class="data"><span
                                                    class="red-font">{{ item.serviceInfo.handleStepAfter }}</span> 个
                                                </div>
                                                <div class="data"><span
                                                    class="red-font">{{ item.serviceInfo.runNumsAfter }}</span> 次
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-theme-operation">
                                        <el-button class="minor-btn" @click="goGraphic(item)">图文说明</el-button>
                                        <el-button v-if="item.isOnlineApply == 1" type="primary"
                                                   @click="chooseSubject(item)">立即办理
                                        </el-button>
                                    </div>
                                </div>

                            </el-carousel-item>
                        </el-carousel>-->
                    </div>
                </div>
            </div>

            <div class="main-content-section" wzades="主题集成服务" aria-label="主题集成服务">
                <div class="main-content-title">
                    <div class="main-content-title-bg">主题集成服务</div>
                </div>
                <div class="main-content-content">
                    <div class="search-line">
                        <el-input
                            wzades="输入您要办理的主题名称进行搜索"
              aria-label="输入您要办理的主题名称进行搜索" placeholder="请输入主题名称搜索"
                            @keyup.enter.native="getChildTypeList(1)"
                            v-model="searchThemeName">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="getChildTypeList(1)"></i>
                        </el-input>
                    </div>
                    <div class="main-content-themeType_carousel" wzades="主题集成服务分类入口" aria-label="主题集成服务分类入口">
                        <button type="button" class="el-carousel__arrow el-carousel__arrow--left"
                                @click="activePageIndex--" v-show="activePageIndex != 0"><i
                            class="el-icon-arrow-left"></i></button>
                        <button type="button" class="el-carousel__arrow el-carousel__arrow--right"
                                @click="activePageIndex++" v-show="activePageIndex != pagesLeftArr.length - 1"><i
                            class="el-icon-arrow-right"></i></button>
                        <div class="themeType-carousel-tabs-box">
                            <div class="themeType-carousel-tabs-container" ref="tabsContainer"
                                 v-bind:style="{ left: left + 'px' }">
                                <button class="md-btn-text_conmon themeType-carousel-tabs" v-for="(type, index) in themeTypes" :tabindex="activeThemeType == index ? '0' : '-1'" :key="type.typeCode"
                                     :class="{'is_active': activeThemeType === index}" @keyup="(e) => changeThemeTypeByKeyUp(e, index)"
                                     @click="changeThemeType(index)">
                                    {{ type.typeName }}
                                </button>
                            </div>
                        </div>

                    </div>
                    <template v-if="themeList.length > 0">
                        <el-row :gutter="30" class="theme-list">
                            <el-col :span="8" v-for="(theme,index) in themeList.slice(0,showNum)" :key="theme.typeSeq">
                                <div class="theme" :class="{'tab': activeThemeTab === index}" tabindex="0" @keyup.tab="onThemeTab(index)" title="图片：一件事集成办理">
                                    <div class="theme-img">
                                        <img v-if="theme.showPic"
                                             :src="`/ApprUnionInterface/api/attachfile/download.v?openOnline=true&stream=true&attachPath=${theme.showPic}`"
                                             @error="handleImageError(theme)" alt/>
                                        <img v-else src="../../../../assets/img/column/theme-default.svg" alt="">
                                    </div>

                                    <div class="theme-name">
                                        <div class="ellipsis-more" :title="theme.typeName">{{ theme.typeName }}</div>
                                    </div>
                                    <div class="theme-operate">
                                        <button class="md-btn-text_conmon btn" tabindex="0" @click="goGraphic(theme)">图文说明</button>
                                        <button class="md-btn-text_conmon btn" tabindex="0" v-if="theme.isOnlineApply == 1" @click="chooseSubject(theme)" @blur="activeThemeTab = ''">
                                            立即办理
                                        </button>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <button class="md-btn-text_conmon common-show-more" tabindex="0" v-if="showToggleBtn" @click="changeStatus" @keyup.enter="onToggleEnter">
                            <span class="text">{{ showComplete ? '收起' : '查看更多' }}</span>
                            <i :class="[showComplete ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
                        </button>
                    </template>
                    <template v-else>
                        <el-empty :image="noData" description="暂无主题数据"></el-empty>
                    </template>

                </div>
            </div>
        </div>

        <choose-area-dialog ref="chooseAreaDialog" :cities="cities" :districts="districts"></choose-area-dialog>

        <side-float-btns></side-float-btns>
    </div>
</template>
<script>
import defaultBanner from '@/assets/img/column/banner.png'
import noData from '@/assets/img/column/no-data.svg'
import Banner from '@/components/Banner'
import SideFloatBtns from '@/components/SideFloatBtns'
import chooseAreaDialog from './components/chooseAreaDialog';
import {
    doSaveSnapshot,
    loadParamByKey,
    getOutnetConfig,
    getAreaInfo,
    getAreaList,
    hotTypesOnline,
    getThemeTypeList,
    loadThemeList,
    baseInfo
} from "@/utils/indexUrl";
import {loadSSInfo} from "@/utils/jointApplyUrl";
import {Loading} from "element-ui";
import {buriedPointFunc} from "../../../../assets/utils/buriedPoint";
import {methodsBuriedPoint} from "../../../../assets/utils/utils";

export default {
    name: 'index',
    data() {
        return {
            defaultBanner: defaultBanner,
            bannerPic: '',
            cities: [],
            districts: [],
            hotThemes: [],
            themeTypes: [],
            tabsLeftArr: [],
            pagesLeftArr: [],
            activePageIndex: 0,
            activeThemeType: 0,
            searchThemeName: '',
            themeList: [],
            showToggleBtn: false,
            showComplete: false,
            showNum: 9,
            baseInfo: {},
            noData: noData,
        activeHotTheme: 0,
        activeThemeTab: ''
      }
    },
    computed: {
        left() {
            return -this.pagesLeftArr[this.activePageIndex];
        }
    },
    filters: {
        enterpriseFormat(val) {
            // 0：个人，1：代表企业（默认），2个人/企业
            switch (+val) {
                case 0:
                    return '个人'
                case 1:
                    return '法人'
                case 2:
                    return '个人/法人'
                default:
                    return '无'
            }
        },
    },
    components: {
        Banner,
        chooseAreaDialog,
        SideFloatBtns
    },
    watch: {
        '$store.state.chosenAreaInfo': {
            handler: function (val, oldVal) {
                if (val && val.jcAreaSeq && (!oldVal || oldVal.jcAreaSeq != val.jcAreaSeq))
                    this.getHotTypes(val.jcAreaSeq)
                this.getSubjectsTypeList(val.jcAreaSeq)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        clickIndicator(index) {
        this.activeHotTheme = index
      },
      onkeydownFun(e){
        //事件对象兼容
        let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
        if (!e1) {
          return false
        }
        //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
        if (e1.keyCode == 37 ||e1.keyCode == 38) {
          // 按左箭头和上箭头
          if (this.activeHotTheme > 0) {
            this.activeHotTheme--
          }
        } else if (e1.keyCode == 39 ||e1.keyCode == 40) {
          // 按右箭头和下箭头
          if (this.activeHotTheme < this.hotThemes.length - 1) {
            this.activeHotTheme++
          }
        }
        let btn = document.getElementsByClassName('indicator')[this.activeHotTheme]
        btn.focus()
      },handleImageError(theme) {
            theme.showPic = ''
        },
        // 获取首页banner图
        getBannerPic() {
            loadParamByKey({
                paramKey: 'YJSZL_BANNER'
            }, res => {
                if (+res.status === 200 && res.data) {
                    this.bannerPic = res.data.paramValue
                } else {
                    console.error(res.desc)
                }
            })
        },
        onToggleEnter() {
        this.$nextTick(() => {
          if (showComplete) {
            this.activeThemeTab = 9
            let btn = document.getElementsByClassName('theme')[this.activeThemeTab]
            btn.focus()
          }
        })
      },// 主题列表点击查看更多
        changeStatus() {
            if (this.showComplete) {
                this.showComplete = false
                this.showNum = 9
            } else {
                this.showComplete = true
                this.showNum = this.themeList.length
            }
        },
        handleShoreMore() {
            if (this.themeList.length < 10) {
                this.showToggleBtn = false
                this.showNum = this.themeList.length
            } else {
                this.showToggleBtn = true
                this.showNum = 9
            }
        },
        // 切换主题分类
        changeThemeType(index) {
            let params = {
                typeName: type.typeName || "", //场景名称
            }
            methodsBuriedPoint("YjsIndexPageScene", "点击“场景分类”", params); //进行事件埋点
            this.activeThemeType = index
            this.activeThemeTab = ''
            this.getChildTypeList()},
      changeThemeTypeByKeyUp(e, index) {
        //事件对象兼容
        let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
        if (!e1) {
          return false
        }
        //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
        if (e1.keyCode == 37 ||e1.keyCode == 38) {
          // 按左箭头和上箭头
          if (index > 0) {
            index--
          }
        } else if (e1.keyCode == 39 ||e1.keyCode == 40) {
          // 按右箭头和下箭头
          if (index < this.themeTypes.length - 1) {
            index++
          }
        }
        let btn = document.getElementsByClassName('themeType-carousel-tabs')[index]
        btn.focus()
      },
      onThemeTab(index) {
        this.activeThemeTab = index
        },
        // 获取弹框地区数据
        async getDialogAreaList() {
            // 获取配置的顶部region
            const res = await getOutnetConfig({
                key: 'APPRONETHING_REGION'
            })
            if (+res.status === 200) {
                // 获取顶部region的areaInfo，将返回的数据装到弹框的市级数据
                const areaRes = await getAreaInfo({
                    jcAreaSeq: res.data.value,
                    auditType: "internal"
                })
                if (+areaRes.status === 200 && areaRes.data) {
                    this.cities[0] = areaRes.data
                    // 获取该市级下所有区级数据
                    const res = await getAreaList({
                        pareAreaSeq: areaRes.data.areaSeq,
                        pageRowNum: 999,
                        auditType: "internal"
                    })
                    if (+res.status === 200) {
                        this.districts = res.data.dataList
                    }
                }
            } else {
                this.$message.error('获取配置参数失败')
            }
        },
        async loadAreaInfo(jcAreaSeq) {
            try {
                // 获取用于头部展示的地区名称
                const areaRes = await getAreaInfo({
                    jcAreaSeq,
                    auditType: "internal"
                })
                if (+areaRes.status === 200 && areaRes.data) {
                    this.$store.commit('setChosenAreaInfo', areaRes.data)
                    // 已选市级：进入一件事专栏，弹出选择地区弹窗，提示申请人选择需要办理的地区
                    // 已选区级：已选区级才进专栏，这种无需再次选择地区
                    if (areaRes.data.areaLevel == 2) {
                        this.$store.commit('setShowToggleArea', true)
                    }
                } else {
                    this.$message.warning('地区参数无效')
                }
            } catch (err) {
                console.log(err)
            }
        },
        getHotTypes(jcAreaSeq) { // 根据地区获取热门主题信息
            hotTypesOnline({
                jcAreaSeq,
                channelTypeFlag: '1', //1-pc 3-移动端
            }, res => {
                if (+res.status == 200) {
                    this.hotThemes = res.data
                } else {
                    this.$message.error(res.desc)
                }
            })
        },
        async getSubjectsTypeList() {
            if (!this.$store.state.chosenAreaInfo || !this.$store.state.chosenAreaInfo.jcAreaSeq) {
                return false
            }
            this.themeTypes = []
            this.tabsLeftArr = []
            this.pagesLeftArr = []
            this.activePageIndex = 0
            const loading = Loading.service()
            try {
                const themeTypeListData = await getThemeTypeList({
                    jcAreaSeq: this.$store.state.chosenAreaInfo.jcAreaSeq, // 行政区域编号
                    investSeq: '10' // 投资主体主键（3-建设工程，10-一件事）
                })
                loading.close()
                if (+themeTypeListData.status === 200 && themeTypeListData.data) {
                    this.themeTypes = themeTypeListData.data

                    this.$nextTick(() => {

                        // 遍历每个二级场景tab的宽度，获取每页能展示的个数
                        let tabs = this.$refs.tabsContainer.children
                        let totalWidth = 0
                        this.tabsLeftArr.push(0)
                        this.pagesLeftArr.push(0)
                        for (let i = 0; i < tabs.length; i++) {
                            totalWidth += tabs[i].clientWidth + 30 // 30是margin
                            this.tabsLeftArr[i + 1] = totalWidth
                            if (totalWidth > 1080 * this.pagesLeftArr.length) {
                                this.pagesLeftArr.push(this.tabsLeftArr[i])
                            }
                        }
                    })

                    if (themeTypeListData.data.length > 0) {

                        await this.getChildTypeList()
                    } else {
                        this.$message.error('该地区无主题分类数据！')
                    }
                } else {
                    this.$alert(themeTypeListData.desc || '获取主题分类数据失败！', '提示', {
                        confirmButtonText: '确定'
                    })
                }
            } catch (err) {
                console.log(err)
                loading.close()
                this.$message.error('获取接口数据异常！')
            }

        },
        //主题名称搜索
        async getChildTypeList(isSearch) {
            if (isSearch){
                let params = {
                    typeName: this.searchThemeName || "", //主题名称
                }
                methodsBuriedPoint("YjsIndexPageSearch", "点击主题名称查询", params); //进行事件埋点
            }
            this.themeList = []
            this.handleShoreMore()
            const loading = Loading.service()
            try {
                if (isSearch) {
                    this.activeThemeType = ''
                } else {
                    this.searchThemeName = ''
                }
                // 获取一级分类下主题信息
                const themeListData = await loadThemeList({
                    typeCode: this.themeTypes[this.activeThemeType]?.typeCode,
                    jcAreaSeq: this.$store.state.chosenAreaInfo.jcAreaSeq,
                    typeName: this.searchThemeName,
                    channelTypeFlag: '1', //1-pc  3-移动端
                    // isOnlineApply: this.isHanding ? 1 : "",
                    // version: this.version
                })
                loading.close()
                if (+themeListData.status === 200 && themeListData.data) {
                    // 处理一级分类下的主题信息
                    if (themeListData.data.childTypeList && themeListData.data.childTypeList.length) {
                        this.themeList = themeListData.data.childTypeList;
                        this.handleShoreMore()
                    } else {
                        if (isSearch) {
                            this.$message.warning('暂无主题数据，请切换地区进行查看')
                        }
                    }
                } else {
                    this.$message.error(themeListData.desc || '获取主题数据失败！')
                }
            } catch (err) {
                console.log(err)
                loading.close()
                this.$message.error('数据异常！')
            }
        },
        // 获取基本信息
        async getBaseInfo(typeSeq) {
            try {
                let res = await baseInfo({
                    jcAreaSeq: this.$store.state.chosenAreaInfo.jcAreaSeq,
                    typeSeq
                })
                if (+res.status === 200) {
                    sessionStorage.setItem('baseInfo', JSON.stringify(res.data))
                    this.baseInfo = res.data
                } else {
                    this.$message.error(res.desc || '获取基本信息失败')
                }
            } catch (err) {
                console.log(err)
                this.$message.error('获取基本信息失败')
            }
        },
        async goGraphic(theme) {
            let params = {
                typeName: theme.typeName || "", //主题名称
            }
            methodsBuriedPoint("YjsGuidanceDirectory", "点击专栏页主题“图文说明”", params); //进行事件埋点
            await this.getBaseInfo(theme.typeSeq)
            if (theme.pictureMode == 1) {
                this.$router.push(`/graphicInstructions?jcAreaSeq=${this.$store.state.chosenAreaInfo.jcAreaSeq}&typeSeq=${theme.typeSeq}`)
            } else {
                this.$router.push('/serviceDetails')
            }

        },
        async chooseSubject(subject) {
            let params = {
                typeName: subject.typeName || "", //主题名称
            }
            methodsBuriedPoint("YjsIndexPageHandle", "点击专栏页主题“立即办理”", params); //进行事件埋点
            // 选择主题后清空unionControlSeq，避免上次办件影响
            sessionStorage.setItem("unionControlSeq", '');
            await this.getBaseInfo(subject.typeSeq)
            if (subject.isOnlineApply == 1) {
                // 判断是否跳到指定网页
                if (this.baseInfo.applyClickStatus == 2) {
                  window.location.href = this.baseInfo.applyClickUrl
                  return false
                }
                if (this.baseInfo.dealinfoEnable) {
                    this.$router.push('/handlingInstructions')
                } else {
                    this.goNair()
                }
            } else {
                this.$router.push('/serviceDetails')
            }
        },
        async goNair() {
            // if (this.baseInfo.surveyEnable || this.baseInfo.surveyAddEnable == 1) {
            //   this.$router.push('/questionNair')
            // } else {
            //   // 没有问卷直接生成主题快照编号，去到导办指南页面
            //   await this._doSaveSnapshot()
            //   this.$router.push('/serviceDetails?isGuidance=1')
            // }

            this.$router.push('/questionNair')
        },
        async _doSaveSnapshot() {
            try {
                let res = await doSaveSnapshot({
                    typeSeq: this.baseInfo.typeSeq,
                    handleType: '1' // 办理模式（1：直接办理，2：前期辅导，3：智能引导）
                });
                if (+res.status === 200 || (+res.status === 400 && res.data)) {
                    if (+res.status === 200) {
                        await this._loadSSInfo(res.data.typeSnapshotSeq)
                    }
                } else {
                    this.$message.error(res.desc)
                }
            } catch (err) {
                this.$message.error(err)
            }

        },
        async _loadSSInfo(typeSnapSeq) {
            if (!typeSnapSeq) {
                return false
            }
            try {
                let res = await loadSSInfo({
                    bizTypeSSSeq: typeSnapSeq
                })
                if (+res.status === 200) {
                    sessionStorage.setItem('sSInfo', JSON.stringify(res.data))
                } else {
                    this.$message.error(res.desc || '获取主题快照信息失败')
                }
            } catch (err) {
                this.$message.error(err)
            }
        }
    },
    async created() {
        this.getBannerPic()
        // 获取弹框地区数据
        await this.getDialogAreaList()

        if (this.$route.query.region) { // 链接上带region参数情况下，获取areaInfo,保存到vuex和sessionStorage
            await this.loadAreaInfo(this.$route.query.region)
        } else if (!this.$store.state.chosenAreaInfo) { // vuex和sessionStorage都没有保存areaInfo的情况下，要弹框
            this.$message.warning('请您先选择地区后再查看办理主题')
            this.$store.commit('setShowToggleArea', true)
        } // 还有一种情况，vuex或sessionStorage有保存areaInfo的情况下，直接使用即可，不需处理。
    },
    mounted() {
        // 进行埋点，记录页面事件
        let obj = {
            title: document.title || "", //页面名称
            actionId: "YjsIndexPage", //事件ID
            account: "ThemeItem", //系统标识
        }
        buriedPointFunc(obj)
    }
}
</script>
<style lang="scss">
.column-container {
    .banner-title {
        font-size: 42px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;

        .banner-subtitle {
            margin-top: 24px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 34px;

            .info {
                margin: 0 60px 0 12px;
            }

            .banner-icon {
                display: inline-block;
                vertical-align: middle;
                width: 18px;
                height: 18px;
                background: url("~@/assets/img/column/icon-checked.svg") no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .main-content {
        margin-bottom: 70px;

        .main-content-section {
            .main-content-title {
                width: 100%;
                height: 60px;
                background: url("../../../../assets/img/column/title-bg.svg") no-repeat center center;
                font-size: 42px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #0D1C28;
                line-height: 60px;
                text-align: center;
                margin-top: 75px;

                .main-content-title-bg {
                    display: inline-block;
                    padding: 0 25px;
                    background: url("../../../../assets/img/column/title-round.svg") no-repeat;
                }
            }

            .main-content-content {
                width: 1200px;
                margin: 40px auto 0;

                .main-content-content_dash {
                    border-radius: 8px;
                    border: 1px solid transparent;
                    background: linear-gradient(#F4F9FD, #F4F9FD) padding-box,
                    repeating-linear-gradient(-45deg, #4391F4 0, #4391F4 0.5em, #F4F9FD 0, #F4F9FD 0.75em);
                    padding: 30px 50px;
                    font-size: 21px;
                    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                    font-weight: 400;
                    color: #727475;
                    line-height: 40px;

                    .blue-font {
                        color: #4391F4;
                    }
                }

        .main-content-content_shadow{
          background: #FFFFFF;
          box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.2000);
          height: 563px;
          position: relative;
          overflow: hidden;
          .indicators-group{
            position: absolute;
            right: 10px;
            top: 30px;
            z-index: 999;
            .indicator{
              width: 15px;
              height: 15px;
              margin-right: 15px;
              padding: 0;
              border-radius: 50%;
              background: #C4E5FF;
              border: none;
              cursor: pointer;
            }
            .indicator:hover{
              opacity: .72;
            }
            .indicator.is-active{
              width: 26px;
              background: #4391F4;
              border-radius: 7.5px;
            }
          }
          .theme-container{
            position: absolute;
            left: 0;
            transition: left 0.4s ease-in-out;
            .carousel-theme{
              display: inline-block;
              width: 1200px;
              text-align: center;
              padding-top: 50px;
            }
            .carousel-theme-title{
              font-size: 30px;
              font-family: Helvetica;
              color: #0D1C28;
              line-height: 36px;
              position:relative;
              display: inline-block;
              padding: 0 5px;
              .carousel-theme-title_bg{
                height: 15px;
                background: #A9CFFF;
                border-radius: 5px;
                position:absolute;
                left: 0;
                bottom: 0;
                z-index: -1;
                width: 100%;
              }
            }
            .carousel-theme-type{
              word-break: keep-all;
              white-space:nowrap;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #FFA051;
              line-height: 25px;
              padding: 3px 26px;
              background: rgba(255, 160, 81, 0.1);
              border-radius: 23px;
              margin-left: 15px;
              position:absolute;
              top:6px;
              left: 100%;
            }
            .carousel-theme-intro{
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #727475;
              line-height: 22px;
              margin-top: 15px;
              margin-bottom: 25px;
            }
            .carousel-theme-compare{
              width: 900px;
              background: #F4F9FD;
              border-radius: 8px;
              margin: 0 auto;
              padding: 30px 50px;
              .carousel-theme-compare_icon{
                text-align: right;
                margin-bottom: 20px;
                .icon{
                  display: inline-block;
                  text-align: center;
                  width: 132px;
                  margin-right: 44px;
                  img{
                    margin-bottom: 10px;
                  }
                  div{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #0D1C28;
                    line-height: 25px;
                  }
                }
              }
              .carousel-theme-compare-data{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #727475;
                line-height: 60px;
                margin-bottom: 20px;
                .compare-title{
                  width: 114px;
                  display: inline-block;
                  vertical-align: middle;
                  background: #EFF1F2;
                  border-radius: 10px;
                  margin-right: 20px;
                }
                .compare-data{
                  width: 766px;
                  display: inline-block;
                  vertical-align: middle;
                  text-align:right;
                  background: #EFF1F2;
                  border-radius: 10px;
                  .data{
                    display: inline-block;
                    text-align: center;
                    width: 132px;
                    margin-right: 44px;
                  }
                }
              }
              .carousel-theme-compare-data.old-data{
                .compare-data{
                  .data{
                    text-decoration:line-through
                  }
                }
              }
              .carousel-theme-compare-data.new-data{
                color: #4391F4;
                margin-bottom: 0;
                .compare-title{
                  background: #D6EDFF;
                }
                .compare-data{
                  background: #D6EDFF;
                  .red-font{
                    color: #FB6B2B;
                    font-size:26px;
                  }
                }
              }
            }
            .carousel-theme-operation{
              margin-top: 30px;
              .el-button {
                border-radius: 0;
                border: none;
                padding: 0 38px;
                height: 48px;
                margin: 0 10px;
                font-size: 16px;
              }
              .minor-btn{
                width: 140px;
                height: 48px;
                background: #FFFFFF;
                border: 1px solid #4391F4;
              }
            }
          }
        }
        .main-content-content_carousel{
          height: 100%;
          .el-carousel__container{
            height: 100%;
          }
          .el-carousel__indicators--horizontal{
            top: 40px;
            right: 15px;
            left: auto;
            transform: none;
            height: 15px;
          }
          .el-carousel__indicator--horizontal{
            padding: 0;
          }
          .el-carousel__button{
            width: 15px;
            height: 15px;
            margin-right: 15px;
            padding: 0;
            border-radius: 50%;
            background: #C4E5FF;
          }
          .el-carousel__indicator--horizontal.is-active{
            .el-carousel__button{
              width: 26px;
              background: #4391F4;
              border-radius: 7.5px
            }
          }


        }
        .main-content-themeType_carousel{
          height: 66px;
          background: #F4F9FD;
          border-radius: 4px;
          position: relative;

                    .themeType-carousel-tabs-box {
                        width: 1080px;
                        height: 66px;
                        margin: 0 60px;
                        position: absolute;
                        overflow: hidden;
                    }

                    .themeType-carousel-tabs-container {
                        white-space: nowrap;
                        position: absolute;
                        left: 0;
                        transition-property: left;
                        transition-duration: 0.5s;
                    }

                    .themeType-carousel-tabs {
                        display: inline-block;
                        text-align: center;
                        font-size: 24px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #727475;
                        line-height: 66px;
                        cursor: pointer;
                        margin: 0 15px;
                    }

                    .themeType-carousel-tabs:hover {
                        color: #4391F4;
                    }

                    .themeType-carousel-tabs.is_active {
                        color: #4391F4;
                        border-bottom: 5px solid #4391F4;
                        line-height: 56px;
                    }

                    .el-carousel__arrow {
                        background: none;
                        color: #B2B2B2;
                        font-size: 24px;

                        border: none;
                        outline: 0;
                        padding: 0;
                        margin: 0;
                        height: 36px;
                        width: 36px;
                        cursor: pointer;
                        -webkit-transition: .3s;
                        transition: .3s;
                        border-radius: 50%;
                        position: absolute;
                        top: 50%;
                        z-index: 10;
                        -webkit-transform: translateY(-50%);
                        transform: translateY(-50%);
                        text-align: center;

                        i {
                            font-weight: bold;
                        }
                    }

                    .el-carousel__arrow:hover {
                        color: #4391F4;
                    }

                    .el-carousel__arrow--left {
                        left: 10px;
                    }

                    .el-carousel__arrow--right {
                        right: 10px;
                    }
                }

                .search-line {
                    text-align: right;
                    margin-bottom: 40px;

                    .el-input {
                        width: 350px;
                    }
                }

                .theme-list {
                    margin-top: 20px;

                    .theme {
                        height: 100px;
                        background: #FFFFFF;
                        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.0700);
                        margin-bottom: 30px;
                        display: flex;

                        .theme-img, .theme-name, .theme-operate {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                        }

                        .theme-operate {
                            display: none;
                            width: 104px;
                            padding-right: 20px;

                            .btn {
                                width: 104px;
                                height: 33px;
                                display: inline-block;
                                vertical-align: middle;
                                text-align: center;
                                background: #4391F4;
                                border-radius: 7px;
                                font-size: 18px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 33px;
                                cursor: pointer;
                            }

                            .btn:hover {
                                background: #ffffff;
                                color: #4391f4;
                            }
                        }

                        .theme-img {
                            width: 140px;
                            overflow: hidden;

                            img {
                                width: 100%;
                            }
                        }

                        .theme-name {
                            flex: 1;
                            margin: 0 20px;
                            font-size: 18px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #0D1C28;
                            line-height: 25px;
                        }
                    }

                    .theme:hover , .theme.tab{
                        background: #4391F4;

                        .theme-img {
                            display: none;
                        }

                        .theme-name {
                            color: #FFFFFF;
                        }

                        .theme-operate {
                            display: flex;
                        }
                    }
                }
            }
        }
    }

    .el-empty {
        padding: 86px 0 0;
    }
}
</style>
